module.exports = __webpack_public_path__ + "static/media/10.115d6e68.mp3";